<div id="base">
  <div class="offcanvas"></div>

  <div id="content">
    <section class="tv2-section">

      <!-- Migration progress overlay -->
      <div class="tv2-modal-backdrop" *ngIf="migrating">
        <div class="tv2-loading-card">
          <i class="ph ph-circle-notch tv2-spin"></i>
          <span>{{ 'transportMigrationIsInProgressPleaseWait' | translate }}</span>
        </div>
      </div>

      <!-- Page head: tabs left, year + actions right -->
      <div class="tv2-page-head">
        <div class="tv2-tabs tv2-slider" role="tablist" aria-label="Transport Sections">
          <span class="tv2-tab-indicator tv2-slide-indicator" aria-hidden="true"></span>
          <button type="button" class="tv2-tab" [class.active]="activeTab === 'BUS'" role="tab" (click)="setTab('BUS')">{{ 'tv2Buses' | translate }}</button>
          <button type="button" class="tv2-tab" [class.active]="activeTab === 'ROUTE'" role="tab" (click)="setTab('ROUTE')">{{ 'tv2Routes' | translate }}</button>
          <button type="button" class="tv2-tab" [class.active]="activeTab === 'STOP'" role="tab" (click)="setTab('STOP')">{{ 'tv2Stops' | translate }}</button>
          <button type="button" class="tv2-tab" [class.active]="activeTab === 'TERMS'" role="tab" (click)="setTab('TERMS')">{{ 'tv2Terms' | translate }}</button>
        </div>

        <div class="tv2-head-actions">
          <button type="button" class="tv2-btn-ghost" *ngIf="migrationStarted" (click)="openModal('migrate')">
            <i class="ph ph-arrows-left-right"></i><span>{{ 'migrateTransport' | translate }}</span>
          </button>
          <a class="tv2-btn-ghost" [routerLink]="['/transport']" [title]="'tv2UseOldTransport' | translate">
            <i class="ph ph-arrow-counter-clockwise"></i><span>{{ 'tv2UseOldTransport' | translate }}</span>
          </a>
          <select class="tv2-year-select" aria-label="Academic Year" [ngModel]="currentAcademicId"
            (ngModelChange)="academicChanged($event)" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let ac of academicList" [ngValue]="ac.pkAcademicId">
              {{ ac.Year }}<ng-container *ngIf="ac.current"> ({{ 'tv2Current' | translate }})</ng-container>
            </option>
          </select>
        </div>
      </div>

      <!-- ================= Shared table toolbar / pager ================= -->
      <ng-template #tvToolbar let-t="t" let-cols="cols" let-file="file">
        <div class="tv2-toolbar">
          <div class="tv2-search">
            <i class="ph ph-magnifying-glass"></i>
            <input type="text" class="tv2-field-input" [(ngModel)]="t.search" (ngModelChange)="t.onSearch()"
              [ngModelOptions]="{standalone: true}" [placeholder]="'tv2Search' | translate" />
          </div>
          <div class="tv2-toolbar-right">
            <select class="tv2-field-input tv2-size" [(ngModel)]="t.size" (ngModelChange)="t.onSize()" [ngModelOptions]="{standalone: true}">
              <option *ngFor="let n of t.sizes" [ngValue]="n">{{ n }}</option>
            </select>
            <button type="button" class="tv2-btn-ghost" [disabled]="t.filtered.length === 0" (click)="exportTable(t, cols, file, 'xlsx')">
              <i class="ph ph-file-xls"></i><span>Excel</span>
            </button>
            <button type="button" class="tv2-btn-ghost" [disabled]="t.filtered.length === 0" (click)="exportTable(t, cols, file, 'csv')">
              <i class="ph ph-file-csv"></i><span>CSV</span>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template #tvPager let-t="t">
        <div class="tv2-pager" *ngIf="t.filtered.length > 0">
          <span class="tv2-pager-info">{{ t.filtered.length }} {{ 'total' | translate }}</span>
          <div class="tv2-pager-btns">
            <button type="button" class="tv2-btn-ghost" [disabled]="t.page <= 1" (click)="t.go(t.page - 1)"><i class="ph ph-caret-left"></i><span>{{ 'previous' | translate }}</span></button>
            <b>{{ t.page }} / {{ t.pages }}</b>
            <button type="button" class="tv2-btn-ghost" [disabled]="t.page >= t.pages" (click)="t.go(t.page + 1)"><span>{{ 'next' | translate }}</span><i class="ph ph-caret-right"></i></button>
          </div>
        </div>
      </ng-template>

      <!-- ================= BUSES ================= -->
      <ng-container *ngIf="activeTab === 'BUS'">
        <div class="tv2-stats">
          <div class="tv2-stat">
            <span class="tv2-stat-icon tv2-t-teal"><i class="ph ph-bus"></i></span>
            <div class="tv2-stat-text"><span class="tv2-label">{{ 'activeTransportation' | translate }}</span><b class="tv2-num">{{ activeBus }}</b></div>
          </div>
          <div class="tv2-stat">
            <span class="tv2-stat-icon tv2-t-maple"><i class="ph ph-bus"></i></span>
            <div class="tv2-stat-text"><span class="tv2-label">{{ 'inactiveTransportation' | translate }}</span><b class="tv2-num">{{ inActiveBus }}</b></div>
          </div>
          <div class="tv2-stat">
            <span class="tv2-stat-icon tv2-t-sky"><i class="ph ph-van"></i></span>
            <div class="tv2-stat-text"><span class="tv2-label">{{ 'totalVehicles' | translate }}</span><b class="tv2-num">{{ totalVehicles }}</b></div>
          </div>
        </div>

        <div class="tv2-panel">
          <div class="tv2-details-head">
            <h3>{{ 'tv2Vehicles' | translate }}</h3>
            <div class="tv2-head-actions">
              <div class="tv2-subtabs tv2-slider">
                <span class="tv2-subtab-indicator tv2-slide-indicator" aria-hidden="true"></span>
                <button type="button" class="tv2-subtab" [class.tv2-subtab-active]="busFilter === 'all'" (click)="setBusFilter('all')">{{ 'all' | translate }}</button>
                <button type="button" class="tv2-subtab" [class.tv2-subtab-active]="busFilter === 'active'" (click)="setBusFilter('active')">{{ 'active' | translate }}</button>
                <button type="button" class="tv2-subtab" [class.tv2-subtab-active]="busFilter === 'inactive'" (click)="setBusFilter('inactive')">{{ 'inactive' | translate }}</button>
              </div>
              <button type="button" class="tv2-btn-primary" (click)="openAddBus()">
                <i class="ph ph-plus"></i><span>{{ 'addNewVehicle' | translate }}</span>
              </button>
            </div>
          </div>

          <ng-container *ngFor="let kind of ['all', 'active', 'inactive']">
            <ng-container *ngIf="busFilter === kind">
              <ng-container *ngTemplateOutlet="tvToolbar; context: { t: busTables[kind], cols: busColumns, file: kind === 'all' ? 'all_buses_export' : (kind === 'active' ? 'active_transport_export' : 'inactive_transport_export') }"></ng-container>
              <div class="tv2-wrap">
                <table class="tv2-table">
                  <thead>
                    <tr>
                      <th *ngFor="let c of busColumns" [class.tv2-th-sort]="c.sortable" (click)="c.sortable && busTables[kind].sort(c.key)">
                        {{ c.label | translate }}
                        <i class="ph" *ngIf="busTables[kind].sortKey === c.key && c.key" [ngClass]="busTables[kind].sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="busLoading && busTables[kind].rows.length === 0"><td [attr.colspan]="busColumns.length" class="tv2-empty-cell"><i class="ph ph-circle-notch tv2-spin"></i> {{ 'tv2Loading' | translate }}</td></tr>
                    <tr *ngIf="!busLoading && busTables[kind].filtered.length === 0">
                      <td [attr.colspan]="busColumns.length" class="tv2-empty-cell">
                        {{ (kind === 'all' ? 'tv2NoBuses' : (kind === 'active' ? 'tv2NoActiveBuses' : 'tv2NoInactiveBuses')) | translate }}
                      </td>
                    </tr>
                    <tr *ngFor="let b of busTables[kind].pageRows" [rowEntrance]="b.pkBusId">
                      <td class="tv2-strong">{{ b.BusName }}</td>
                      <td>{{ b.staffName }}</td>
                      <td>{{ b.BusNumber }}</td>
                      <td>{{ b.busInChargeName }}</td>
                      <td>
                        <a class="tv2-link" (click)="openStudents(b)">{{ b.Capacity }} ({{ b.assignedStudents }})</a>
                      </td>
                      <td><span class="tv2-chip" [class.tv2-chip-on]="b.BusStatus === 'RUNNING'">{{ statusLabelKey(b.BusStatus) | translate }}</span></td>
                      <td class="tv2-actions">
                        <button type="button" class="tv2-row-icon-btn" [attr.aria-label]="'update' | translate" (click)="busDetail(b, kind, 'editBus')"><i class="ph ph-note-pencil"></i></button>
                        <button type="button" class="tv2-row-icon-btn tv2-row-icon-btn-danger" *ngIf="canDeleteBus(b, kind)" [attr.aria-label]="'delete' | translate" (click)="busDetail(b, kind, 'deleteBus')"><i class="ph ph-trash"></i></button>
                        <button type="button" class="tv2-row-icon-btn" [attr.aria-label]="'tv2BusDetails' | translate" (click)="busDetail(b, kind, 'viewBus')"><i class="ph ph-info"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-container *ngTemplateOutlet="tvPager; context: { t: busTables[kind] }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>

      <!-- ================= ROUTES ================= -->
      <ng-container *ngIf="activeTab === 'ROUTE'">
        <div class="tv2-panel">
          <div class="tv2-details-head">
            <h3>{{ 'tv2Routes' | translate }}</h3>
            <button type="button" class="tv2-btn-primary" (click)="openAddRoute()"><i class="ph ph-plus"></i><span>{{ 'tv2AddRoute' | translate }}</span></button>
          </div>
          <ng-container *ngTemplateOutlet="tvToolbar; context: { t: routeTable, cols: routeColumns, file: 'route_list_export' }"></ng-container>
          <div class="tv2-wrap">
            <table class="tv2-table">
              <thead>
                <tr>
                  <th *ngFor="let c of routeColumns" [class.tv2-th-sort]="c.sortable" (click)="c.sortable && routeTable.sort(c.key)">
                    {{ c.label | translate }}
                    <i class="ph" *ngIf="routeTable.sortKey === c.key && c.key" [ngClass]="routeTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="routeTable.filtered.length === 0"><td [attr.colspan]="routeColumns.length" class="tv2-empty-cell">{{ 'tv2NoRoutes' | translate }}</td></tr>
                <tr *ngFor="let r of routeTable.pageRows" [rowEntrance]="r.pkRouteId">
                  <td class="tv2-strong">{{ r.RouteName }}</td>
                  <td>{{ r.startName }}</td>
                  <td>{{ r.endName }}</td>
                  <td>
                    <a class="tv2-link" [class.tv2-warn]="r.assignedStops < r.TotalStop" (click)="showRouteWarning(r)">{{ r.TotalStop }}</a>
                  </td>
                  <td>
                    <button type="button" class="tv2-row-icon-btn" [attr.aria-label]="'tv2AssignStops' | translate" (click)="openAssignStops(r)"><i class="ph ph-map-pin-line"></i></button>
                  </td>
                  <td class="tv2-actions">
                    <button type="button" class="tv2-row-icon-btn" [attr.aria-label]="'editRoute' | translate" (click)="routeDetail(r, 'editRoute')"><i class="ph ph-note-pencil"></i></button>
                    <button type="button" class="tv2-row-icon-btn tv2-row-icon-btn-danger" [attr.aria-label]="'delete' | translate" (click)="routeDetail(r, 'deleteRoute')"><i class="ph ph-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-container *ngTemplateOutlet="tvPager; context: { t: routeTable }"></ng-container>
        </div>
      </ng-container>

      <!-- ================= STOPS ================= -->
      <ng-container *ngIf="activeTab === 'STOP'">
        <div class="tv2-panel">
          <div class="tv2-details-head">
            <h3>{{ 'tv2Stops' | translate }}</h3>
            <button type="button" class="tv2-btn-primary" (click)="openAddStop()"><i class="ph ph-plus"></i><span>{{ 'tv2AddStop' | translate }}</span></button>
          </div>
          <ng-container *ngTemplateOutlet="tvToolbar; context: { t: stopTable, cols: stopColumns, file: 'stops_list_export' }"></ng-container>
          <div class="tv2-wrap">
            <table class="tv2-table">
              <thead>
                <tr>
                  <th *ngFor="let c of stopColumns" [class.tv2-th-sort]="c.sortable" (click)="c.sortable && stopTable.sort(c.key)">
                    {{ c.label | translate }}<span *ngIf="c.key === 'fare'"> ({{ currType }})</span>
                    <i class="ph" *ngIf="stopTable.sortKey === c.key && c.key" [ngClass]="stopTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="stopTable.filtered.length === 0"><td [attr.colspan]="stopColumns.length" class="tv2-empty-cell">{{ 'tv2NoStops' | translate }}</td></tr>
                <tr *ngFor="let s of stopTable.pageRows" [rowEntrance]="s.PkBusStopId">
                  <td class="tv2-strong">{{ s.BusStopName }}</td>
                  <td>{{ s.fare }}</td>
                  <td>{{ termCount }}</td>
                  <td class="tv2-actions">
                    <button type="button" class="tv2-row-icon-btn" [attr.aria-label]="'editBusStop' | translate" (click)="openEditStop(s)"><i class="ph ph-note-pencil"></i></button>
                    <button type="button" class="tv2-row-icon-btn tv2-row-icon-btn-danger" [attr.aria-label]="'delete' | translate" (click)="openDeleteStop(s)"><i class="ph ph-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-container *ngTemplateOutlet="tvPager; context: { t: stopTable }"></ng-container>
        </div>
      </ng-container>

      <!-- ================= TERMS ================= -->
      <ng-container *ngIf="activeTab === 'TERMS'">
        <div class="tv2-panel">
          <div class="tv2-details-head">
            <h3>{{ 'tv2Terms' | translate }}</h3>
            <button type="button" class="tv2-btn-primary" (click)="openAddTerm()"><i class="ph ph-plus"></i><span>{{ 'tv2AddTerm' | translate }}</span></button>
          </div>
          <ng-container *ngTemplateOutlet="tvToolbar; context: { t: termTable, cols: termColumns, file: 'term_list_export' }"></ng-container>
          <div class="tv2-wrap">
            <table class="tv2-table">
              <thead>
                <tr>
                  <th *ngFor="let c of termColumns" [class.tv2-th-sort]="c.sortable" (click)="c.sortable && termTable.sort(c.key)">
                    {{ c.label | translate }}
                    <i class="ph" *ngIf="termTable.sortKey === c.key && c.key" [ngClass]="termTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="termTable.filtered.length === 0"><td [attr.colspan]="termColumns.length" class="tv2-empty-cell">{{ 'tv2NoTerms' | translate }}</td></tr>
                <tr *ngFor="let t of termTable.pageRows" [rowEntrance]="t.pkBusStopTermId">
                  <td class="tv2-strong">{{ t.termName }}</td>
                  <td>{{ t.termDueDate | date: 'dd-MMM-yyyy' }}</td>
                  <td>{{ t.termStartDate | date: 'dd-MMM-yyyy' }}</td>
                  <td>{{ t.termEndDate | date: 'dd-MMM-yyyy' }}</td>
                  <td class="tv2-actions">
                    <button type="button" class="tv2-row-icon-btn" [attr.aria-label]="'tv2EditTerm' | translate" (click)="openEditTerm(t)"><i class="ph ph-note-pencil"></i></button>
                    <button type="button" class="tv2-row-icon-btn tv2-row-icon-btn-danger" [attr.aria-label]="'delete' | translate" (click)="openDeleteTerm(t)"><i class="ph ph-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-container *ngTemplateOutlet="tvPager; context: { t: termTable }"></ng-container>
        </div>
      </ng-container>

      <!-- ================= MODALS ================= -->

      <!-- Add bus -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'addBus'" (click)="closeModal()">
        <div class="tv2-modal tv2-modal-wide" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head">
            <h3>{{ 'addNewVehicle' | translate }}</h3>
            <button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button>
          </div>
          <div class="tv2-modal-body">
            <div class="tv2-form-grid">
              <div><label class="tv2-field-label">{{ 'busName' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="addBusForm.BusName" /></div>
              <div><label class="tv2-field-label">{{ 'busNumber' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="addBusForm.BusNumber" /></div>
              <div>
                <label class="tv2-field-label">{{ 'driverName' | translate }}</label>
                <select class="tv2-field-input" [(ngModel)]="addBusForm.fkStaffId">
                  <option value=""></option>
                  <option *ngFor="let d of driverList" [value]="d.staffId">{{ d.DriverName }}</option>
                </select>
              </div>
              <div>
                <label class="tv2-field-label">{{ 'busInCharge' | translate }}</label>
                <select class="tv2-field-input" [(ngModel)]="addBusForm.InChargeId">
                  <option value=""></option>
                  <option *ngFor="let d of driverList" [value]="d.staffId">{{ d.DriverName }}</option>
                </select>
              </div>
              <div><label class="tv2-field-label">{{ 'capacity' | translate }}</label><input type="number" class="tv2-field-input" [(ngModel)]="addBusForm.Capacity" /></div>
              <div>
                <label class="tv2-field-label">{{ 'defineRoute' | translate }}</label>
                <select class="tv2-field-input" [(ngModel)]="addBusForm.fkRouteId">
                  <option value=""></option>
                  <option *ngFor="let r of busRouteList" [value]="r.pkRouteId">{{ r.RouteName }}</option>
                </select>
              </div>
              <div class="tv2-span-2"><label class="tv2-field-label">{{ 'trackingDeviceId' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="addBusForm.DeviceId" /></div>
              <div class="tv2-span-2">
                <label class="tv2-field-label">{{ 'tv2VehicleStatus' | translate }}</label>
                <div class="tv2-radio-row">
                  <label class="tv2-radio"><input type="radio" name="tv2AddBusStatus" [(ngModel)]="addBusForm.BusStatus" value="RUNNING" /> {{ 'active' | translate }}</label>
                  <label class="tv2-radio"><input type="radio" name="tv2AddBusStatus" [(ngModel)]="addBusForm.BusStatus" value="NOT_RUNNING" /> {{ 'inactive' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" [disabled]="saving" (click)="saveNewBus()">
              <i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'addBus' | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Edit bus -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'editBus'" (click)="closeModal()">
        <div class="tv2-modal tv2-modal-wide" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head">
            <h3>{{ 'updateBus' | translate }}</h3>
            <button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button>
          </div>
          <div class="tv2-modal-body">
            <div class="tv2-empty" *ngIf="busDetailLoading"><i class="ph ph-circle-notch tv2-spin"></i></div>
            <div class="tv2-form-grid" *ngIf="!busDetailLoading">
              <div><label class="tv2-field-label">{{ 'busNumber' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="busForm.BusNumber" /></div>
              <div><label class="tv2-field-label">{{ 'busName' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="busForm.BusName" /></div>
              <div>
                <label class="tv2-field-label">{{ 'driverName' | translate }}</label>
                <select class="tv2-field-input" [(ngModel)]="busForm.fkStaffId">
                  <option value=""></option>
                  <option *ngFor="let d of driverList" [value]="d.staffId">{{ d.DriverName }}</option>
                </select>
              </div>
              <div>
                <label class="tv2-field-label">{{ 'busInCharge' | translate }}</label>
                <select class="tv2-field-input" [(ngModel)]="busForm.BusInCharge">
                  <option value=""></option>
                  <option *ngFor="let d of driverList" [value]="d.staffId">{{ d.DriverName }}</option>
                </select>
              </div>
              <div><label class="tv2-field-label">{{ 'capacity' | translate }}</label><input type="number" class="tv2-field-input" [(ngModel)]="busForm.Capacity" /></div>
              <div>
                <label class="tv2-field-label">{{ 'defineRoute' | translate }}</label>
                <select class="tv2-field-input" [(ngModel)]="busForm.fkRouteId">
                  <option value=""></option>
                  <option *ngFor="let r of busRouteList" [value]="r.pkRouteId">{{ r.RouteName }}</option>
                </select>
              </div>
              <div class="tv2-span-2">
                <label class="tv2-field-label">{{ 'tv2VehicleStatus' | translate }}</label>
                <div class="tv2-radio-row">
                  <label class="tv2-radio"><input type="radio" name="tv2EditBusStatus" [(ngModel)]="busForm.BusStatus" value="RUNNING" /> {{ 'active' | translate }}</label>
                  <label class="tv2-radio"><input type="radio" name="tv2EditBusStatus" [(ngModel)]="busForm.BusStatus" value="NOT_RUNNING" /> {{ 'inactive' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" [disabled]="saving || busDetailLoading" (click)="saveBusEdit()">
              <i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'update' | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- View bus -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'viewBus'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head">
            <h3>{{ 'tv2BusDetails' | translate }} — {{ busDetails.BusNumber }}</h3>
            <button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button>
          </div>
          <div class="tv2-modal-body">
            <div class="tv2-empty" *ngIf="busDetailLoading"><i class="ph ph-circle-notch tv2-spin"></i></div>
            <dl class="tv2-dl" *ngIf="!busDetailLoading">
              <dt>{{ 'tv2BusRoute' | translate }}</dt><dd>{{ busDetails.startName }} <i class="ph ph-arrow-right"></i> {{ busDetails.endName }}</dd>
              <dt>{{ 'busName' | translate }}</dt><dd>{{ busDetails.BusName }}</dd>
              <dt>{{ 'totalStops' | translate }}</dt><dd>{{ selectedBusData?.TotalStop }}</dd>
              <dt>{{ 'tv2BusTrackingId' | translate }}</dt><dd>{{ busDetails.DeviceId }}</dd>
              <dt>{{ 'tv2TotalSeats' | translate }}</dt><dd>{{ selectedBusData?.Capacity }}</dd>
              <dt>{{ 'tv2FilledSeats' | translate }}</dt><dd>{{ selectedBusData?.assignedStudents }}</dd>
              <dt>{{ 'tv2RemainingSeats' | translate }}</dt><dd>{{ remainingSeats() }}</dd>
            </dl>
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'close' | translate }}</button>
          </div>
        </div>
      </div>

      <!-- Delete bus -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'deleteBus'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'tv2Warning' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body"><p>{{ 'doYouReallyWantToDeleteTheBus' | translate }}</p></div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary tv2-btn-danger" [disabled]="saving" (click)="deleteBus()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'delete' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Students on a bus -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'students'" (click)="closeModal()">
        <div class="tv2-modal tv2-modal-xl" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head">
            <h3>{{ 'studentsListForOptedBus' | translate }} — {{ selectedBusData?.BusName }}</h3>
            <button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button>
          </div>
          <div class="tv2-modal-body tv2-body-flush">
            <div class="tv2-empty" *ngIf="studentsLoading"><i class="ph ph-circle-notch tv2-spin"></i> {{ 'tv2Loading' | translate }}</div>
            <ng-container *ngIf="!studentsLoading">
              <ng-container *ngTemplateOutlet="tvToolbar; context: { t: studentTable, cols: studentColumns, file: 'all_buses_export' }"></ng-container>
              <div class="tv2-wrap">
                <table class="tv2-table">
                  <thead>
                    <tr>
                      <th *ngFor="let c of studentColumns" class="tv2-th-sort" (click)="studentTable.sort(c.key)">
                        {{ c.label | translate }}
                        <i class="ph" *ngIf="studentTable.sortKey === c.key" [ngClass]="studentTable.sortDir === 'asc' ? 'ph-caret-up' : 'ph-caret-down'"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="studentTable.filtered.length === 0"><td [attr.colspan]="studentColumns.length" class="tv2-empty-cell">{{ 'tv2NoStudents' | translate }}</td></tr>
                    <tr *ngFor="let s of studentTable.pageRows">
                      <td class="tv2-strong">{{ s.studentName }}</td>
                      <td>{{ s.parentName }}</td>
                      <td>{{ s.mobileNumber }}</td>
                      <td>{{ s.registrationId }}</td>
                      <td>{{ s.class }}</td>
                      <td>{{ s.BusNumber }}</td>
                      <td>{{ s.BusName }}</td>
                      <td>{{ s.Capacity }}</td>
                      <td>{{ s.RouteName }}</td>
                      <td>{{ s.BusStopName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-container *ngTemplateOutlet="tvPager; context: { t: studentTable }"></ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Add route -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'addRoute'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'addNewRoute' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body">
            <label class="tv2-field-label">{{ 'routeName' | translate }}</label>
            <input type="text" class="tv2-field-input" [(ngModel)]="addRouteForm.RouteName" />
            <label class="tv2-field-label">{{ 'startingPoint' | translate }}</label>
            <select class="tv2-field-input" [(ngModel)]="addRouteForm.StartPoint">
              <option value=""></option>
              <option *ngFor="let s of busStopList" [value]="s.PkBusStopId">{{ s.BusStopName }}</option>
            </select>
            <label class="tv2-field-label">{{ 'endingPoint' | translate }}</label>
            <select class="tv2-field-input" [(ngModel)]="addRouteForm.EndPoint">
              <option value=""></option>
              <option *ngFor="let s of busStopList" [value]="s.PkBusStopId">{{ s.BusStopName }}</option>
            </select>
            <label class="tv2-field-label">{{ 'noOfStops' | translate }}</label>
            <input type="number" class="tv2-field-input" [(ngModel)]="addRouteForm.TotalStops" />
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" [disabled]="saving" (click)="saveNewRoute()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'add' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Edit route -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'editRoute'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'editRoute' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body">
            <label class="tv2-field-label">{{ 'routeName' | translate }}</label>
            <input type="text" class="tv2-field-input" [(ngModel)]="routeForm.RouteName" />
            <label class="tv2-field-label">{{ 'startingPoint' | translate }}</label>
            <select class="tv2-field-input" [(ngModel)]="routeForm.StartPoint">
              <option value=""></option>
              <option *ngFor="let s of busStopList" [value]="s.PkBusStopId">{{ s.BusStopName }}</option>
            </select>
            <label class="tv2-field-label">{{ 'endingPoint' | translate }}</label>
            <select class="tv2-field-input" [(ngModel)]="routeForm.EndPoint">
              <option value=""></option>
              <option *ngFor="let s of busStopList" [value]="s.PkBusStopId">{{ s.BusStopName }}</option>
            </select>
            <label class="tv2-field-label">{{ 'noOfStops' | translate }}</label>
            <input type="number" class="tv2-field-input" [(ngModel)]="routeForm.TotalStop" />
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" [disabled]="saving" (click)="saveRouteEdit()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'save' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Delete route -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'deleteRoute'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'tv2Warning' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body"><p>{{ 'doYouReallyWantToDeleteTheRoutes' | translate }}</p></div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary tv2-btn-danger" [disabled]="saving" (click)="deleteRoute()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'delete' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Assign stops to a route -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'assignStops'" (click)="closeModal()">
        <div class="tv2-modal tv2-modal-wide" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head">
            <h3>{{ 'tv2AssignStops' | translate }} — {{ selectedRoute?.RouteName }}</h3>
            <button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button>
          </div>
          <div class="tv2-modal-body">
            <p class="tv2-hint">{{ 'total' | translate }} {{ selectedRoute?.TotalStop }} {{ (selectedRoute?.TotalStop > 1 ? 'tv2Stops' : 'tv2Stop') | translate }}</p>
            <div class="tv2-empty" *ngIf="assignLoading"><i class="ph ph-circle-notch tv2-spin"></i> {{ 'pleaseWaitFetchingStops' | translate }}</div>
            <ng-container *ngIf="!assignLoading">
              <div class="tv2-assign-row" *ngFor="let row of assignRows; let i = index">
                <select class="tv2-field-input" [(ngModel)]="row.stopId" [disabled]="row.lockedStop" [ngModelOptions]="{standalone: true}">
                  <option value="">{{ 'selectStop' | translate }}</option>
                  <option *ngFor="let s of busStopList" [value]="s.PkBusStopId">{{ s.BusStopName }}</option>
                </select>
                <input type="text" class="tv2-field-input tv2-assign-no" [(ngModel)]="row.stopNumber" [disabled]="row.lockedNumber || row.lockedStop"
                  [ngModelOptions]="{standalone: true}" [attr.aria-label]="'stopNumber' | translate" />
              </div>
              <button type="button" class="tv2-btn-ghost" *ngIf="remainingStopsToAssign > 0" (click)="addAssignRow()">
                <i class="ph ph-plus"></i><span>{{ 'tv2AddAnotherStop' | translate }}</span>
              </button>
            </ng-container>
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" *ngIf="hasNewAssignRows" [disabled]="saving" (click)="saveAssignedStops()">
              <i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'save' | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Add stop -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'addStop'" (click)="closeModal()">
        <div class="tv2-modal tv2-modal-xl" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'addBusStop' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body tv2-stop-body">
            <div>
              <label class="tv2-field-label">{{ 'stopName' | translate }}</label>
              <input type="text" class="tv2-field-input" [(ngModel)]="addStopForm.BusStopName" />
              <label class="tv2-field-label">{{ 'perTermFare' | translate }} ({{ currType }})</label>
              <input type="number" class="tv2-field-input" [(ngModel)]="addStopForm.fare" />
              <label class="tv2-field-label">{{ 'tv2SearchLocation' | translate }}</label>
              <input type="text" class="tv2-field-input" id="tv2AddStopSearch" [placeholder]="'tv2SearchLocation' | translate" />
              <div class="tv2-form-grid">
                <div><label class="tv2-field-label">{{ 'latitude' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="addStopForm.Latitude" readonly /></div>
                <div><label class="tv2-field-label">{{ 'longitude' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="addStopForm.Longitude" readonly /></div>
              </div>
            </div>
            <div id="tv2AddStopMap" class="tv2-map"></div>
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" [disabled]="saving" (click)="saveNewStop()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'save' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Edit stop -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'editStop'" (click)="closeModal()">
        <div class="tv2-modal tv2-modal-xl" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'editBusStop' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body tv2-stop-body">
            <div>
              <label class="tv2-field-label">{{ 'stopName' | translate }}</label>
              <input type="text" class="tv2-field-input" [(ngModel)]="stopForm.BusStopName" />
              <label class="tv2-field-label">{{ 'fare' | translate }} ({{ currType }})</label>
              <input type="number" class="tv2-field-input" [(ngModel)]="stopForm.Busfare" />
              <label class="tv2-field-label">{{ 'tv2SearchLocation' | translate }}</label>
              <input type="text" class="tv2-field-input" id="tv2EditStopSearch" [placeholder]="'tv2SearchLocation' | translate" />
              <div class="tv2-form-grid">
                <div><label class="tv2-field-label">{{ 'latitude' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="stopForm.Latitude" readonly /></div>
                <div><label class="tv2-field-label">{{ 'longitude' | translate }}</label><input type="text" class="tv2-field-input" [(ngModel)]="stopForm.Longitude" readonly /></div>
              </div>
            </div>
            <div id="tv2EditStopMap" class="tv2-map"></div>
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" [disabled]="saving" (click)="saveStopEdit()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'update' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Delete stop -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'deleteStop'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'tv2Warning' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body"><p>{{ 'doYouReallyWantToDeleteTheStop' | translate }}</p></div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary tv2-btn-danger" [disabled]="saving" (click)="deleteStop()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'delete' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Add term -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'addTerm'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'tv2AddTerm' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body">
            <label class="tv2-field-label">{{ 'termName' | translate }}</label>
            <input type="text" class="tv2-field-input" [(ngModel)]="addTermForm.termName" />
            <label class="tv2-field-label">{{ 'tv2TermDue' | translate }}</label>
            <input type="date" class="tv2-field-input" [(ngModel)]="addTermForm.termDue" />
            <label class="tv2-field-label">{{ 'tv2TermStart' | translate }}</label>
            <input type="date" class="tv2-field-input" [(ngModel)]="addTermForm.termStart" />
            <label class="tv2-field-label">{{ 'tv2TermEnd' | translate }}</label>
            <input type="date" class="tv2-field-input" [(ngModel)]="addTermForm.termEnd" />
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" [disabled]="saving" (click)="saveNewTerm()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'save' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Edit term -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'editTerm'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'tv2EditTerm' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body">
            <label class="tv2-field-label">{{ 'termName' | translate }}</label>
            <input type="text" class="tv2-field-input" [(ngModel)]="termForm.termName" />
            <label class="tv2-field-label">{{ 'tv2TermDue' | translate }}</label>
            <input type="date" class="tv2-field-input" [(ngModel)]="termForm.termDue" />
            <label class="tv2-field-label">{{ 'tv2TermStart' | translate }}</label>
            <input type="date" class="tv2-field-input" [(ngModel)]="termForm.termStart" />
            <label class="tv2-field-label">{{ 'tv2TermEnd' | translate }}</label>
            <input type="date" class="tv2-field-input" [(ngModel)]="termForm.termEnd" />
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary" [disabled]="saving || !termForm.termName || !termForm.termDue || !termForm.termStart || !termForm.termEnd" (click)="saveTermEdit()">
              <i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'update' | translate }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Delete term -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'deleteTerm'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'tv2Warning' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body"><p>{{ 'doYouReallyWantToDeleteTheTerm' | translate }}</p></div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'cancel' | translate }}</button>
            <button type="button" class="tv2-btn-primary tv2-btn-danger" [disabled]="saving" (click)="deleteTerm()"><i class="ph ph-circle-notch tv2-spin" *ngIf="saving"></i><span>{{ 'delete' | translate }}</span></button>
          </div>
        </div>
      </div>

      <!-- Migrate transport -->
      <div class="tv2-modal-backdrop" *ngIf="modal === 'migrate'" (click)="closeModal()">
        <div class="tv2-modal" (click)="$event.stopPropagation()">
          <div class="tv2-modal-head"><h3>{{ 'tv2TransportMigration' | translate }}</h3><button type="button" class="tv2-modal-close" (click)="closeModal()"><i class="ph ph-x"></i></button></div>
          <div class="tv2-modal-body">
            <p>{{ 'doYouWantToImportTransportDataSettingsFrom' | translate }} <b>{{ previousAcademic?.Year }} → {{ currentAcademicYear?.Year }}</b>?</p>
          </div>
          <div class="tv2-modal-foot">
            <button type="button" class="tv2-btn-ghost" (click)="closeModal()">{{ 'no' | translate }}</button>
            <button type="button" class="tv2-btn-primary" (click)="migrateTransport()"><span>{{ 'yes' | translate }}</span></button>
          </div>
        </div>
      </div>

    </section>
  </div>
</div>
